var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5784 10.4312C17.5784 14.752 14.2055 18.2546 10.0448 18.2546C5.88412 18.2546 2.5112 14.752 2.5112 10.4312C2.5112 6.11047 5.88412 2.60781 10.0448 2.60781C14.2055 2.60781 17.5784 6.11047 17.5784 10.4312ZM18.111 20.6516C17.0321 19.5312 15.2879 19.475 13.8572 20.0849C12.6816 20.5861 11.3943 20.8624 10.0448 20.8624C4.49721 20.8624 0 16.1922 0 10.4312C0 4.67021 4.49721 0 10.0448 0C15.5924 0 20.0896 4.67021 20.0896 10.4312C20.0896 11.9215 19.7887 13.3388 19.2464 14.6212C18.6738 15.9755 18.7291 17.6055 19.7491 18.6647L25.1456 24.2689C25.6226 24.7642 25.6226 25.548 25.1456 26.0433C24.6425 26.5657 23.8061 26.5657 23.303 26.0433L18.111 20.6516Z",
    fill: "#272829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d61be2325ac52e4d5facf0c81a1a6d40.svg";
export { ForwardRef as ReactComponent };